import CodeIcon from '@mui/icons-material/Code';
import SellIcon from '@mui/icons-material/Sell';
import {NavigationMenu, NavigationMenuProps} from '../../navigation/NavigationMenu';
import {NavigationMenuEntry} from '../../navigation/types';
import {ComponentWithoutChildren} from '../../react/types';
import {Paths, createPath} from '../../routes/paths';

// Add menu items to the list below.
// Each sub-array of items will be separated by a divider.
export const menuItems: NavigationMenuEntry[][] = [
  [
    {
      iconType: CodeIcon,
      path: createPath(Paths.Welcome),
      subEntries: [
        {path: createPath(Paths.Welcome, '#0'), translationKey: 'main:navigation.public.product.features'},
        {path: createPath(Paths.Welcome, '#1'), translationKey: 'main:navigation.public.product.libraries'},
        {path: createPath(Paths.Welcome, '#2'), translationKey: 'main:navigation.public.product.foundations'},
      ],
      translationKey: 'main:navigation.public.product',
    },
    {
      iconType: SellIcon,
      path: createPath(Paths.Pricing),
      translationKey: 'main:navigation.public.pricing',
    },
  ],
];

type PublicNavigationMenuProps = Omit<NavigationMenuProps, 'menuItems'>;

export const PublicNavigationMenu: ComponentWithoutChildren<PublicNavigationMenuProps> = (
  props: PublicNavigationMenuProps,
) => {
  return <NavigationMenu menuItems={menuItems} {...props} />;
};
